import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Qrcode from '@/components/Qrcode'
import SignupOld from '@/components/Signup'
import Forgot from '@/components/Forgot'
import Signin from '@/new-login-2018/login/Signin'
import Signup from '@/new-login-2018/login/Signup'
import Signupnext from '@/new-login-2018/login/Signupnext'
import Signupphone from '@/new-login-2018/login/Signupphone'
import Signupsuccess from '@/new-login-2018/login/Signupsuccess'
import Scan from '@/new-login-2018/login/Scan'
import Password from '@/new-login-2018/login/Password'
import ForgotPassword from '@/new-login-2018/login/Forgotpassword'
import ResetSuccess from '@/new-login-2018/login/Resetsuccess'
import AccountNotExist from '@/new-login-2018/login/Accountnotexist'
import AccountExist from '@/new-login-2018/login/Accountexist'
import Start from '@/new-login-2018/invite/Start'
import InviteAccountExist from '@/new-login-2018/invite/Accountexist'
import InviteNext from '@/new-login-2018/invite/Invitenext'
import InvitePhone from '@/new-login-2018/invite/Invitephone'
import InviteSuccess from '@/new-login-2018/invite/Invitesuccess'
import InviteError from '@/new-login-2018/invite/Inviteerror'
import NewInviteStart from '@/new-login-2018/new-invite/Start'
import NewInviteNext from '@/new-login-2018/new-invite/Invitenext'
import NewInviteSuccess from '@/new-login-2018/new-invite/Invitesuccess'
import NewInviteError from '@/new-login-2018/new-invite/Inviteerror'
import config from '@/assets/js/config'

Vue.use(Router)

let routes = []
if (config.type === 'login') {
  if (config.isVanish) {
    routes = [{
      path: '/',
      name: 'Qrcode',
      component: Qrcode
    }, {
      path: '/login',
      name: 'Login',
      component: Login
    }, {
      path: '/qrcode',
      name: 'Qrcode',
      component: Qrcode
    }, {
      path: '/signup',
      name: 'SignupOld',
      component: SignupOld
    }, {
      path: '/forgot',
      name: 'Forgot',
      component: Forgot
    }]
  } else {
    routes = [{
      path: '/login/signin',
      name: 'Signin',
      component: Signin
    }, {
      path: '/login/signup',
      name: 'Signup',
      component: Signup
    }, {
      path: '/login/signupnext',
      name: 'Signupnext',
      component: Signupnext
    }, {
      path: '/login/signupphone',
      name: 'Signupphone',
      component: Signupphone
    }, {
      path: '/login/signupsuccess',
      name: 'Signupsuccess',
      component: Signupsuccess
    }, {
      path: '/login/scan',
      name: 'Scan',
      component: Scan
    }, {
      path: '/login/password',
      name: 'Password',
      component: Password
    }, {
      path: '/login/forgotpassword',
      name: 'ForgotPassword',
      component: ForgotPassword
    }, {
      path: '/login/resetsuccess',
      name: 'ResetSuccess',
      component: ResetSuccess
    }, {
      path: '/login/accountnotexist',
      name: 'AccountNotExist',
      component: AccountNotExist
    }, {
      path: '/login/accountexist',
      name: 'AccountExist',
      component: AccountExist
    }, {
      path: '/login/accountexist',
      name: 'AccountExist',
      component: AccountExist
    }]
    if (JSON.parse(localStorage.getItem('passwords')) && JSON.parse(localStorage.getItem('passwords'))[0] && Object.keys(JSON.parse(localStorage.getItem('passwords'))[0])[0] !== 'undefined') {
      routes.unshift({
        path: '/',
        name: 'Signin',
        component: Signin
      })
    } else {
      routes.unshift({
        path: '/',
        name: 'Signup',
        component: Signup
      })
    }
  }
} else if (config.type === 'invite') {
  if (config.isVanish) {
  } else {
    routes = [{
      path: '/',
      name: 'Start',
      component: Start
    }, {
      path: '/invite/start',
      name: 'Start2',
      component: Start
    }, {
      path: '/invite/accountexist',
      name: 'InviteAccountExist',
      component: InviteAccountExist
    }, {
      path: '/invite/invitenext',
      name: 'InviteNext',
      component: InviteNext
    }, {
      path: '/invite/invitephone',
      name: 'InvitePhone',
      component: InvitePhone
    }, {
      path: '/invite/invitesuccess',
      name: 'InviteSuccess',
      component: InviteSuccess
    }, {
      path: '/invite/inviteerror',
      name: 'InviteError',
      component: InviteError
    }]
  }
} else if (config.type === 'newInvite') {
  if (config.isVanish) {
  } else {
    routes = [{
      path: '/',
      name: 'NewInviteStart',
      component: NewInviteStart
    }, {
      path: '/invite/invitenext',
      name: 'NewInviteNext',
      component: NewInviteNext
    }, {
      path: '/invite/invitesuccess',
      name: 'NewInviteSuccess',
      component: NewInviteSuccess
    }, {
      path: '/invite/inviteerror',
      name: 'NewInviteError',
      component: NewInviteError
    }]
  }
}

const router = new Router({
  // mode: 'history',
  // base: '/website/option/share/index.html',
  routes: routes
  // routes: [{
  //   path: '/',
  //   name: 'Qrcode',
  //   component: Qrcode
  // }, {
  //   path: '/login',
  //   name: 'Login',
  //   component: Login
  // }, {
  //   path: '/qrcode',
  //   name: 'Qrcode',
  //   component: Qrcode
  // }, {
  //   path: '/signup',
  //   name: 'Signup',
  //   component: Signup
  // }, {
  //   path: '/forgot',
  //   name: 'Forgot',
  //   component: Forgot
  // }]
  // routes: [{
  //   path: '/',
  //   name: 'Signin',
  //   component: Signin
  // }, {
  //   path: '/login/signin',
  //   name: 'Signin',
  //   component: Signin
  // }, {
  //   path: '/login/signup',
  //   name: 'Signup',
  //   component: Signup
  // }, {
  //   path: '/login/signupnext',
  //   name: 'Signupnext',
  //   component: Signupnext
  // }, {
  //   path: '/login/signupphone',
  //   name: 'Signupphone',
  //   component: Signupphone
  // }, {
  //   path: '/login/signupsuccess',
  //   name: 'Signupsuccess',
  //   component: Signupsuccess
  // }, {
  //   path: '/login/scan',
  //   name: 'Scan',
  //   component: Scan
  // }, {
  //   path: '/login/password',
  //   name: 'Password',
  //   component: Password
  // }, {
  //   path: '/login/forgotpassword',
  //   name: 'ForgotPassword',
  //   component: ForgotPassword
  // }, {
  //   path: '/login/resetsuccess',
  //   name: 'ResetSuccess',
  //   component: ResetSuccess
  // }, {
  //   path: '/login/accountnotexist',
  //   name: 'AccountNotExist',
  //   component: AccountNotExist
  // }, {
  //   path: '/login/accountexist',
  //   name: 'AccountExist',
  //   component: AccountExist
  // }]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js